<ol>
  @for (chapter of chapters(); track chapter.link.href) {
    <li [class.disabled-chapter]="!chapter.link.href || isDisabled()">
      <a
        href="javascript:void(0)"
        (click)="navigateToChapter(chapter.link)"
        [style.padding-inline-start.px]="(chapter.level ?? 0) * 16 + 14"
        >{{ chapter.link.title }}</a
      >
    </li>
  }
</ol>
